// extracted by mini-css-extract-plugin
export default {"container":"ComponentDescription_container__CaRom","componentName":"ComponentDescription_componentName__tKhE6"};